import CardColaboradorComponent from '@/components/colaboradores';
import Seo from '@/components/shared/custom/seo-component';
import { Pages } from '@/constants/rutas';
import { Box, Typography } from '@mui/material';

const ColaboradoresAnaliticaFantasyPage = () => {
    return (
        <Box className="colaboradores-analitica-fantasy-section container">
            <Seo pageId={Pages.COLABORADORES} />

            <Typography variant="h1" className="colaboradores-analitica-fantasy-section__header">
                Colaboradores de Analítica Fantasy
            </Typography>

            <CardColaboradorComponent />
        </Box>
    );
};

export default ColaboradoresAnaliticaFantasyPage;
